<h4 class="m-t-20 m-b-10">
    <input type="checkbox" class="m-r-10" name="customerDetailCheck" (change)="validateInsurance($event.target.checked)" />
    {{ "Replacement Details" | translate }}
</h4>
<table style="background: #f7f7fc; border-radius: 3px; margin-top: 1rem;">
    <thead>
        <tr>
            <th>{{ "REPLACEMENT PRODUCT NAME" | translate }}</th>
            <th>{{ "REPLACEMENT ACCOUNT NUMBER" | translate }}</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>{{ awaitingEscalation.replacementProductName || "--" }}</td>
            <td>{{ awaitingEscalation.replacementAccountNumber || "--" }}</td>
        </tr>
    </tbody>
</table>

<table style="background: #f7f7fc; border-radius: 3px; margin-top: 1rem;">
    <thead>
        <tr>
            <th>{{ "REPLACEMENT IMEI" | translate }}</th>
            <th>{{ "IMEI" | translate }}</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>{{ awaitingEscalation.replacementImei || "--" }}</td>
            <td>{{ awaitingEscalation.imei || "--" }}</td>
        </tr>
    </tbody>
</table>
<table *ngIf="insurancePolicyFlag" style="background: #f7f7fc; border-radius: 3px; margin-top: 1rem;">
    <thead>
        <tr>
            <th>{{ "INSURANCE POLICY NAME" | translate }}</th>
            <th>{{ "CREATED ON" | translate }}</th>
            <th>{{ "VALID UNTIL" | translate }}</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>{{ awaitingEscalation.insurancePolicyName || "--" }}</td>
            <td>{{ awaitingEscalation.insurancePolicyCreated || "--" }}</td>
            <td>{{ awaitingEscalation.insurancePolicyValidUntil || "--" }}</td>
        </tr>
    </tbody>
</table>
<table style="background: #f7f7fc; border-radius: 3px; margin-top: 1rem;">
    <thead>
        <tr>
            <th>{{ "REPLACEMENT REASON" | translate }}</th>
            <th>{{ "REPLACEMENT COMMENTS" | translate }}</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>{{ awaitingEscalation.reasonForReplacement || "--" }}</td>
            <td>{{ awaitingEscalation.replacementComments || "--" }}</td>
        </tr>
    </tbody>
</table>